module.exports = __webpack_public_path__ + "img/lg_ring_r_l_1_0@2x.3b1b42da.png";